import React,{useState,useEffect} from 'react';
import { Routes, Route, Outlet,useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { getClientApi,getEnvApi } from '../../apis/userPermissionApi/userPermissionApi';
import { getAllClientsApi ,getEnvsDataApi} from '../../apis/flowBuilderApi/flowBuilderApi';
import { useDispatch, useSelector } from 'react-redux';
import {setClient, setEnv, setIsUserPermissionConfigured} from '../../app/slice/userPermisssionSlice';
import './ConfigureEnv.css'
import FlowBuilder from "../../pages/FlowBuilder/FlowBuilder"



function ConfigureEnv() {
 
  const dispatch = useDispatch();
  const [clientDetails, setClientDetails] = useState<any>('');
  const [envDetails, setenvDetails] = useState<any>('');
  const [clients,setClients] = useState<any[]>([]);
  const [envs,setEnvs] = useState<any[]>([]);
  const [showLoadFLowDropdown, setShowLoadFLowDropdown] = React.useState(true);
  const [showLoadFlowDiv, setShowLoadFlowDiv] = React.useState(false);
  const [showEnvDropdown, setShowEvnDropdown] = React.useState(false);
  const navigate = useNavigate();
  const EmpId=useSelector((state:any)=>state.authApiSlice.Id);


  useEffect(() => {
    getClientData();
    console.log("EmpId-->",EmpId);
  }, [EmpId])




  const getClientData=()=>{
    getAllClientsApi((res:any)=>{
      console.log("getALLClientApi::",res);
      setClients(res);
    });
  }
  const getEnvData=(clientData:any)=>{
    console.log("get envs.");
    let payload:any={
      "Client_Id":clientData.Id
    };
  getEnvsDataApi(payload,(res:any)=>{
      console.log("getEnvApi::",res);
      setEnvs(res);
    });
  }

  const handleClientChange = (event: SelectChangeEvent) => {
    let clientData:any=event.target.value;
    setClientDetails(clientData);
    setEnvs([]);
    getEnvData(clientData);
  };
  const handleEnvChange = (event: SelectChangeEvent) => {
    let envData:any=event.target.value;
    setenvDetails(envData);
  };
  const handleSubmit= () => {
    setShowLoadFLowDropdown(false);
    setShowLoadFlowDiv(true);
  };



  return (
    <>
    {showLoadFLowDropdown &&
      <div className="user-permission-layout-bg"> 
        <div className='client-id-div'>
            
            <FormControl fullWidth>


              <div>
              <InputLabel id="select-client-label">Select client</InputLabel>
              <Select
              
                id="select-client"
                value={clientDetails.Client_Nm}
                onChange={handleClientChange}
                className="select-client-dropdown"
              >
               { clients?.map((items) => {
                return (
                  <MenuItem key={ items.Id } value={items}>{items.Client_Nm}</MenuItem>)
               })}
              </Select>
              </div>
              </FormControl>
              <FormControl fullWidth disabled={envs?.length===0}>
              <div>
              <InputLabel id="select-env-label">Select Environment</InputLabel>
                <Select
                  labelId="select-env-label"
                  id="select-env"
                  value={envDetails.Env_Nm}
                  onChange={handleEnvChange}
                  className="select-client-dropdown"
                  
                >
                { envs?.map((items) => {
                  return (
                    <MenuItem key={ items.Id } value={items}>{items.Env_Nm }</MenuItem>)
                })}
                </Select>
              </div>
              </FormControl>
       
              <div className='load-flow-btn-div'>
              <button
                  className="rounded-primary-40 btn font--btn load-flow-btn"
                  type="button"
                  onClick={handleSubmit}
                >
                  Load Flow Builder
                </button>
                </div>
            
         </div>
        </div>
    }
        {showLoadFlowDiv && 
      <FlowBuilder Load_Flow_Data={true} Client_Id={clientDetails.Id} Env_List={[envDetails]}/>
    }
</>
          
  );
}

export default ConfigureEnv;







